import PropTypes from 'prop-types';
import RequestSentIcon from '../icons/RequestSentIcon';
import { makeCancelable, validateEmail } from '../utils/utils';
import { Typography } from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import React from 'react';
import { withRouter } from 'react-router-dom';
import BasicBackground from '../BasicBackground';
import Errored from '../Errored';
import { authenticationService } from '../services/security/authenticationService';
import { globalStyles } from '../style/gstheme';
import { MAX_EMAIL_LENGTH } from '../utils/constants';
import AccessHeader from './AccessHeader';

const styles = () => {
    return Object.assign({
        forgotten: {
            textAlign: 'center',
            height: '560px',
            position: 'fixed',
            top: 'calc(50% - 280px)',
            left: 'calc(50% - 192px)',
            width: 384,
            padding: 20,
            borderRadius: 5,
            backgroundColor: 'white',
        }
    }, globalStyles);
};

class ForgottenUsername extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            email: "",
            isErrored: null,
            processing: false,
            completed: false
        };
        this.cancellable = null;
        this.textInput = React.createRef();
    }

    componentWillUnmount() {
        if (this.cancellable) this.cancellable.cancel();
    }

    submit = async () => {
        this.setState({ processing: true }, async () => {
            try {
                const { email } = this.state;
                await this.doForgotten(email).promise;
                if (this.cancellable && this.cancellable.isCancelled()) return;
                this.setState({
                    completed: true,
                    processing: false
                });
            }
            catch (e) {
                if (this.cancellable && this.cancellable.isCancelled()) return;
                const message = [429].includes(e.status) ?
                    e.message
                    :
                    "We cannot process your request at the moment. Please try again later.";
                this.setState({
                    isErrored: { message },
                    processing: false
                });
            }
        });
    };

    doForgotten(email) {
        this.cancellable = makeCancelable(authenticationService.forgottenUsername(email));
        return this.cancellable;
    }

    clearError = () => {
        this.setState({ isErrored: null }, () => this.textInput && this.textInput.current && this.textInput.current.focus());
    };

    handleChange = (event) => {
        const t = event.target;
        this.setState({ [t.name]: t.value });
    };

    render() {

        const { email, isErrored, processing, completed } = this.state;
        const { classes } = this.props;
        const validEmail = validateEmail(email);
        const disabled = email === "" || processing || !validEmail;

        return (
            <BasicBackground>
                <Grid container spacing={0} direction="row" className={classes.forgotten} >
                    <Grid item xs={12}>
                        <AccessHeader title="Forgotten Username" />
                    </Grid>
                    <Grid item xs={12}>
                        <div className={classes.loginEntry}>
                            <Typography className={classes.loginSubHeading}>Email</Typography>
                            <TextField className={classes.loginText}
                                FormHelperTextProps={{
                                    "data-test": "email-helper-text"
                                }}
                                data-test="email"
                                autoComplete="email"
                                margin="dense"
                                disabled={completed}
                                error={email.length > 0 && !validEmail}
                                helperText={email.length > 0 && !validEmail && "This is not a valid email address."}
                                id="email"
                                name="email"
                                value={email}
                                inputRef={this.textInput}
                                autoFocus={true}
                                variant="outlined"
                                placeholder="Email"
                                fullWidth
                                onKeyPress={(ev) => {
                                    if (!disabled && ev.charCode === 13) {
                                        this.submit();
                                        ev.preventDefault();
                                        ev.stopPropagation();
                                    }
                                }}
                                onChange={this.handleChange}
                                InputProps={{
                                    className: classes.loginInput,
                                    inputProps: {
                                        className: classes.loginInput,
                                        maxLength: MAX_EMAIL_LENGTH
                                    }
                                }}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        {completed ?
                            <div>
                                <div style={{ marginBottom: '12px' }}>
                                    <RequestSentIcon style={{ width: '36px', height: '32px' }} />
                                </div>
                                <Typography paragraph variant="h3" className={classes.mainHeadingSecondary}>Information Sent</Typography>
                            </div>
                            :
                            <Typography variant="body2">Information will be sent to this email address.</Typography>
                        }
                    </Grid>
                    <Grid item xs={12}>
                        {completed ?
                            <Typography data-test="instructions" variant="body2">Please check your email.</Typography>
                            :
                            <Fab
                                data-test="send"
                                disabled={disabled}
                                variant="extended"
                                color="secondary"
                                className={classes.button}
                                style={{ width: '120px' }}
                                onClick={() => this.submit()}>Send</Fab>
                        }
                    </Grid>
                </Grid>
                {isErrored && <Errored data={isErrored} clearError={this.clearError} />}
            </BasicBackground>
        );
    }
}

ForgottenUsername.propTypes = {
    classes: PropTypes.object,
    history: PropTypes.object
};

export default withRouter(withStyles(styles)(ForgottenUsername));